import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export enum DeviceType {
  CREW = 'crew',
  CUSTOMER = 'ob02',
  UNKNOWN = 'unknown',
}

@Injectable({
  providedIn: 'root',
})
export class DeviceTypeService {
  private overrideType?: DeviceType;
  private readonly deviceTypeSubject: BehaviorSubject<DeviceType>;
  public readonly deviceType$: Observable<DeviceType>;

  constructor() {
    const initial = this.resolveCurrentDeviceType();
    this.deviceTypeSubject = new BehaviorSubject<DeviceType>(initial);
    this.deviceType$ = this.deviceTypeSubject.asObservable();
  }

  public getDeviceType(): DeviceType {
    if (this.overrideType) {
      return this.overrideType;
    }
    const current = this.resolveCurrentDeviceType();
    if (this.deviceTypeSubject.getValue() !== current) {
      this.deviceTypeSubject.next(current);
    }
    return current;
  }

  public isCrew(): boolean {
    return this.getDeviceType() === DeviceType.CREW;
  }

  public isCustomer(): boolean {
    return this.getDeviceType() === DeviceType.CUSTOMER;
  }

  public setDeviceType(deviceType: DeviceType): void {
    this.overrideType = deviceType;
    this.deviceTypeSubject.next(deviceType);
  }

  public resolveCurrentDeviceType(url?: string): DeviceType {
    try {
      const targetUrl = url !== undefined ? url : typeof window !== 'undefined' ? window.location.href : '';
      const match = /[?&]device(?:type)?=([^&#]+)/i.exec(targetUrl);
      if (match) {
        const rawValue = decodeURIComponent(match[1]).trim();
        const found = Object.values(DeviceType).find((val) => val.toLowerCase() === rawValue.toLowerCase());
        if (found) {
          return found;
        }
      }
    } catch {
      // Fallback on error
    }

    return DeviceType.UNKNOWN;
  }
}
